// extracted by mini-css-extract-plugin
export default {"container":"style_container__mRWaC","main":"style_main__YtWTb"};